module.exports = __webpack_public_path__ + "img/Producer4.7d9adfa1.png";